import React, { useState } from "react";
import TipoEquipoService from "../../services/ListaVerificacion/TipoEquipoService";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";
import { IPostCrearTipoEquipo } from "../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";

export const useAddTipoEquipo = () => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  function PostCrearTipoEquipo(data: IPostCrearTipoEquipo) {
    ocultarMensaje();
    onEnviar();
    TipoEquipoService.PostCrearTipoEquipo(data)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
        }
      })
      .catch((e: Error) => {
        onCancelar();
      });
  }

  const ocultarMensaje = () => {
    setResponse(null!);
  };
  return {
    ocultarMensaje,
    response,
    isSend,
    PostCrearTipoEquipo,
  };
};
